import IMask, {createPipe, FactoryArg, FactoryOpts, Masked} from 'imask';
import TextInput, {TextInputProps} from './TextInput';
import {cn} from '@/lib/tailwind-utils';
import {Input} from '@/shadcn_components/ui/input';
import {useRef, useState, useEffect} from 'react';
import ErrorText from './shared/ErrorText';
import HelperText from './shared/HelperText';
import {useInput} from '@/hooks/useInput';
import {Label} from '@/shadcn_components/ui/label';

export const MaskTextInput = (props: TextInputProps & {maskProps: FactoryArg}) => {
  const {maskProps, ...rest} = props;
  const maskPipe = createPipe(maskProps);
  const unmaskPipe = createPipe(maskProps, IMask.PIPE_TYPE.MASKED, IMask.PIPE_TYPE.TYPED);
  return (
    <TextInput
      {...rest}
      format={value => {
        // console.log('format', value);
        return maskPipe(String(value));
      }}
      parse={value => {
        // console.log('parse', value);
        return unmaskPipe(String(value));
        // return Number((value || '').replace(/[^0-9]/g, ''));
      }}
    />
  );
};

export const MaskTextInput2 = (props: TextInputProps & {maskOptions: FactoryOpts}) => {
  const {field, fieldState} = useInput({...props, parse: undefined, format: undefined});
  const {className, hidden, label} = props;
  const {value = '', onBlur, onChange, name, disabled} = field;
  const inputRef = useRef<any>(null);
  const maskRef = useRef<any>(null);
  const {
    maskOptions,
    format = val => String(val), // Default: No formatting
    parse = val => String(val), // Default: No parsing
    ref,
    ...rest
  } = props;
  // const [maskedValue, setMaskedValue] = useState(''); // Display masked format

  useEffect(() => {
    if (inputRef.current) {
      maskRef.current = IMask(inputRef.current, {...maskOptions, parse, format});

      // Handle changes
      maskRef.current.on('accept', () => {
        // console.log('accept', maskRef.current.value, maskRef.current.unmaskedValue);
        const newMaskedValue = maskRef.current.value;
        // if (maskedValue === maskRef.current.value) return;
        // const newUnmaskedValue = maskRef.current.unmaskedValue;

        // setMaskedValue(newMaskedValue); // Update display value
        onChange(parse(newMaskedValue)); // Update form value
      });

      return () => {
        maskRef.current?.off('accept');
        maskRef.current?.destroy();
      };
    }
  }, []);

  useEffect(() => {
    if (!maskRef.current) return;
    // console.log('value', value, maskRef.current?.unmaskedValue);
    // if (String(value) == String(maskRef.current?.unmaskedValue)) return;

    // console.log('set value', value, 'as masked value', format(value));
    maskRef.current.value = format(value);
    // setMaskedValue(maskRef.current?.value || '');
  }, [value, maskRef.current]);

  return (
    <div className={cn('w-full space-y-1', className)} hidden={hidden}>
      <Label
      // className='text-lg'
      >
        {label}
      </Label>
      <Input
        name={name}
        type="text"
        value={maskRef.current?.value || ''} // do-not update input value directly
        disabled={disabled}
        onChange={e => {
          // console.log('onChange', e.target.value);
          // setMaskedValue(e.target.value);
          // onChange(parse(e.target.value));
        }}
        ref={inputRef}
        // onBlur={onBlur}
        {...rest}
      />
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export const ThousandSeparatorTextInput = (props: TextInputProps) => {
  return (
    <MaskTextInput2
      //// @ts-expect-error
      maskOptions={{
        mask: /^-?[\d\s]*\.?[\d]*$/g, // Allow only numbers and spaces
        // prepare: value => value, //value => value.replace(/\D/g, ''), // Allow only digits
        // format: val => val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','), // Format number with commas
        // parse: val => val.replace(/,/g, ''), // Remove commas for raw value

        // parse: function (value) {
        //   // Remove all non-digit characters except the decimal separator
        //   const cleanedValue = value.replace(/[^\d.,-]/g, '');

        //   // Use parseFloat to handle number parsing correctly
        //   const parsedNumber = parseFloat(cleanedValue.replace(/,/g, '.')); //Important: replace comma with dot before parse
        //   return isNaN(parsedNumber) ? 0 : parsedNumber; // Return 0 if not a number
        // },
        // format: function (value) {
        //   if (!value) return ''; // Handle empty input

        //   const formattedNumber = new Intl.NumberFormat('en-US').format(value); //Use Intl.NumberFormat for formatting

        //   return formattedNumber;
        // },
      }}
      format={val => val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} // Format number with commas
      parse={val => Number(val.replace(/\s/g, ''))} // Remove commas for raw value
      {...props}
    />
  );
};
